import { useQuery } from '@tanstack/vue-query'
import { fetchMe } from './session.service'

export const SESSION_QUERY_KEY = ['session', 'me'] as const

export function useSessionQuery() {
  return useQuery({
    queryKey: SESSION_QUERY_KEY,
    queryFn: fetchMe,
    staleTime: 1000 * 60 * 5, // 5 minutes
  })
}
